import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import ObtenerPais from '../functions/ObtenerPais';
import ObtenerProvincia from '../functions/ObtenerProvincia';
import ObtenerLocalidades from '../functions/ObtenerLocalidades';

import ProvinciaTabla from '../types/ProvinciaTabla';
import PaisSeleccionar from '../types/PaisSeleccionar';
import ProvinciaSeleccionar from '../types/ProvinciaSeleccionar';
import LocalidadSeleccionar from '../types/LocalidadSeleccionar';

interface SeleccionarLocalidadProps {
    paisInicial: number;
    provinciaInicial: number;
    localidadInicial: number;
    onChange: (localidad: LocalidadSeleccionar) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarProvincia: React.FC<SeleccionarLocalidadProps> = ({ paisInicial, provinciaInicial, localidadInicial, onChange, onClear, eliminando }) => {
    
    const localidadVacia = { id: 0, name: '', provincia_id: 0, provincia_nombre: '', pais_id: 0, pais_nombre: '' };
    
    const [pais, setPais] = useState<PaisSeleccionar>({id: 0, iso_code: '', tel_code: '', name: ''});
    const [provincia, setProvincia] = useState<ProvinciaSeleccionar>({id: 0, name: ''});
    
    const [localidades, setLocalidades] = useState<LocalidadSeleccionar[]>([]);

    const [localidadSeleccionada, setLocalidadSeleccionada] = useState<LocalidadSeleccionar>({ id: 0, name: '', provincia_id: 0, provincia_nombre: '', pais_id: 0, pais_nombre: '' });

    const handleLocalidadChange = (event: React.SyntheticEvent, newValue: LocalidadSeleccionar | null) => {
        if (newValue === null) {
            setLocalidadSeleccionada(localidadVacia);
            if (onClear) {
                onClear();
            }
            return;
        }
        setLocalidadSeleccionada(newValue);
        if (onChange) {
            onChange(newValue);
        }

        if (newValue === null && onClear) {
            onClear();
        }
    };

    const fetchPais = async () => {
        const elPais = await ObtenerPais(paisInicial);
        if (elPais.pais_ok === 'si') {
            setPais({
                id: elPais.pais.id,
                iso_code: elPais.pais.codigo_iso,
                tel_code: elPais.pais.codigo_telefonico,
                name: elPais.pais.nombre
            });
        }
    };

    const fetchProvincia = async () => {
        const laProvincia = await ObtenerProvincia(provinciaInicial);
        if (laProvincia.provincia_ok === 'si') {
            setProvincia({
                id: laProvincia.provincia.id,
                name: laProvincia.provincia.provincia,
            });
        }
    };

    const fetchLocalidades = async () => {
        
        const data = await ObtenerLocalidades(paisInicial, provinciaInicial);
        
        const localidadesRecuperadas: LocalidadSeleccionar[] = [];
        
        for (const localidad of data.localidades) {

            localidadesRecuperadas.push({
                id: localidad.id,
                name: localidad.localidad,
                provincia_id: provinciaInicial,
                provincia_nombre: provincia.name,
                pais_id: paisInicial,
                pais_nombre: pais.name
            });
        }
 
        setLocalidades(localidadesRecuperadas);        

        if (localidadInicial > 0) {
            const localidadInicio = data.localidades.find(
                (p: LocalidadSeleccionar) => p.id === localidadInicial
            );
            if (localidadInicio) {
                const localidadInicioOK: LocalidadSeleccionar = {
                    id: localidadInicio.id,
                    name: localidadInicio.localidad,
                    provincia_id: provinciaInicial,
                    provincia_nombre: provincia.name,
                    pais_id: paisInicial,
                    pais_nombre: pais.name
                };
                setLocalidadSeleccionada(localidadInicioOK);
                onChange(localidadInicioOK);
            }
        }
    };

    useEffect(() => {
        fetchPais()
        fetchProvincia();
        fetchLocalidades();
    }, []);

    useEffect(() => {
        fetchPais();
        fetchProvincia();
        fetchLocalidades();
        if (localidadInicial === 0) {
            setLocalidadSeleccionada(localidadVacia);
        }
    }, [paisInicial, provinciaInicial, localidadInicial]);

    return (
        <div className="flex flex-col w-full">
            <Autocomplete<LocalidadSeleccionar>
                options={localidades}
                getOptionLabel={(option: LocalidadSeleccionar) => `${option.name}`}
                renderInput={(params) => <TextField {...params} label="Selecciona una localidad" />}
                value={localidadSeleccionada}
                onChange={handleLocalidadChange}
                isOptionEqualToValue={(option: LocalidadSeleccionar, value: LocalidadSeleccionar) => option.id === value.id}
                renderOption={(props, option: LocalidadSeleccionar) => (
                <li {...props}>
                    {option.name}
                </li>
                )}
                size="small"
                disabled={eliminando}
            />
        </div>
    );
}

export default SeleccionarProvincia;